import { CookieConsentBanner as BannerComponent, useCookieConsentBannerDefaultHandler } from 'db-npm-e4sc-rd-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useContextSettings } from '../../shared/hooks';
import { sanitizeHtml } from '../../shared/utils/sanitizeHtml';

type CookieConsentBannerProps = {
  fields: any;
};

const CookieConsentBanner: React.FC<CookieConsentBannerProps> = ({ fields }) => {
  const { t } = useTranslation();
  const disabled = useContextSettings().cookieBannerDisabled;

  // Extra callback for consent level submit that triggers Adobe Launch "_satellite.track" event
  const onSubmit = () => {
    const w = window as any;
    if (w && w._satellite && w._satellite.track) {
      w._satellite.track('consentupdate');
    }
  };

  // Create handler with extra onSubmit callback
  const handler = useCookieConsentBannerDefaultHandler({
    onSubmit,
    disabled,
  });

  // Make handler onReopen callback accessible from e.g. a link in rich text
  React.useEffect(() => {
    const w = window as any;
    if (w) {
      w.cookieConsentBanner = {
        reopen: handler.onReopen,
      };
    }
  }, [handler.onReopen]);

  if (!useContextSettings().cookiePolicyEnabled) {
    return null;
  }

  return (
    <BannerComponent
      handler={handler}
      title={fields['Title']?.value}
      description={<span dangerouslySetInnerHTML={{ __html: sanitizeHtml(fields['Text']?.value) }} />}
      buttonAllowNecessaryText={t('cookie-consent-buttons-oktonecessary') as string}
      buttonAllowSelectedText={t('cookie-consent-buttons-oktoselected') as string}
      buttonAllowAllText={t('cookie-consent-buttons-oktoall') as string}
      levels={[
        {
          name: t(`cookie-consent-categories-0-title`) as string,
          description: t(`cookie-consent-categories-0-text`) as string,
        },
        {
          name: t(`cookie-consent-categories-1-title`) as string,
          description: t(`cookie-consent-categories-1-text`) as string,
        },
        {
          name: t(`cookie-consent-categories-2-title`) as string,
          description: t(`cookie-consent-categories-2-text`) as string,
        },
        {
          name: t(`cookie-consent-categories-3-title`) as string,
          description: t(`cookie-consent-categories-3-text`) as string,
        },
      ]}
    />
  );
};

export default CookieConsentBanner;
